const BETWEEN_SIZE = 50;

export const placeElement = (x, y, id, element, idToElement) => {
    let newCoords = {};
    let {offsetWidth, offsetHeight} = element;
    let _idToElement = {};
    for (let _id in idToElement) {
        let _element = idToElement[_id].current;
        if (!_element || _id === id) { continue; }
        if (_element.offsetLeft + _element.offsetWidth > x &&
            _element.offsetHeight + _element.offsetTop > y) {
            _idToElement[_id] = _element;
        }
    }

    if (!Object.values(_idToElement).some(
        _element => overlaps(element, _element))) {
        // none of the elements overlap so just place as normal
        return {};
    }

    for (let _id in _idToElement) {
        let _element = _idToElement[_id];
        // then we shift
        newCoords[_id] = {
            x: _element.offsetLeft + offsetWidth + BETWEEN_SIZE,
            y: _element.offsetTop// + offsetHeight
        };
    }
    return newCoords;
};

export const overlaps = (elementA, elementB) => {
    let x1 = elementB.offsetLeft;
    let y1 = elementB.offsetTop;
    let x2 = elementB.offsetWidth + x1;
    let y2 = elementB.offsetHeight + y1;
    return inSelection(
        elementA, x1, y1, x2, y2);
};

export const inSelection = (element, x1, y1, x2, y2) => {
    if (!element) {
        return false;
    }
    let R1 = {
        x1,
        y1,
        x2,
        y2,
    };
    let R2 = {
        x1: element.offsetLeft,
        y1: element.offsetTop,
        x2: element.offsetLeft + element.offsetWidth,
        y2: element.offsetTop + element.offsetHeight,
    };

    return (R1.x1 < R2.x2 && R1.x2 > R2.x1 &&
            R1.y1 < R2.y2 && R1.y2 > R2.y1) ;

};

